export class AbstractFile {
    public isNextcloudFile: boolean = false;
    public isLocalFile: boolean = false;
    public isMailAttachement: boolean = false;
    public type: string;
}
export class LocalFile extends AbstractFile {
    public blob: File;
    public localName: string;
    public size: number;
}
export class NextcloudFile extends AbstractFile {
    public eTag: string;
    public fileId: string;
    public href: string;
    public isItself: boolean;
    public lastModified: string;
    public size: string;
    public uuid: string;
}
export class NextcloudPathInfo {
    convertedPath: string;
    initialPath: string;
    initialPathIncludesNextcloudPrefix: boolean;
    initialPathIncludesNextcloudUsername: boolean;
    isFile: boolean;
    isFolder: boolean;
    nextcloudUsername: string;
    nextcloudUserNameMissing: boolean;
    pathIsEmpty: boolean;
    prettyPathArray: string[];
    relativeConvertedPath: string;
    rootFolderName: string;
}
